import { deserializeSuperjson } from '@lib/superjson';
import type {
  PreviewQuoteEmailRequest,
  PreviewQuoteEmailResponse,
} from '@snap-types/actions/preview-quote-email';
import { injectEndpoints } from '@ui/store/api-builder/inject-mutation';

const injectedApi = injectEndpoints({
  endpoints: (builder) => ({
    previewQuoteEmail: builder.mutation<
      PreviewQuoteEmailResponse,
      PreviewQuoteEmailRequest
    >({
      transformResponse: deserializeSuperjson,
      query: ({ siteCode, quoteEmailTemplate }) => ({
        url: `/admin/sites/${siteCode.toLowerCase()}/preview-quote-email`,
        method: 'POST',
        body: { quoteEmailTemplate },
      }),
    }),
  }),
});

const previewQuoteEmail = injectedApi.endpoints.previewQuoteEmail;

export const usePreviewQuoteEmailMutation = previewQuoteEmail.useMutation;
